// extracted by mini-css-extract-plugin
export default {"p":"_98f6e8613d b8ea6425a2 _55307bb860","clr":"ab3c7a4351","dls":"_9098d26188"};